import {Button} from "@mui/material";

// The secondary (outlined) counterpart of FilledButton. Wraps MUI Button so it shares
// ripple, keyboard focus and the brand outlined styling defined once in the theme.
export default function LineButton({onClick, children, fullWidth = false, disabled = false, type = "button"}) {
    return (
        <Button
            type={type}
            variant="outlined"
            onClick={onClick}
            disabled={disabled}
            fullWidth={fullWidth}
            sx={{gap: '0.5em'}}
        >
            {children}
        </Button>
    );
}
